const accordionItems = document.querySelectorAll('[data-accordion]')
const tabBtns = document.querySelectorAll('[data-tab-name]')
const tabs = document.querySelectorAll('[data-tab]')

let currentAccordion = false

document.addEventListener('DOMContentLoaded', () => {
  // share btn
  // accordionShare()

  // fix a firefox bug
  tabs.forEach( tab => {
    tab.style.removeProperty('display')
  })

  // let's set these before we open one
  accordionItems.forEach( accordion => {
    setTop(accordion)
  })

  const paths = window.location.pathname.split('/')
  if (paths[4] !== '') {
    console.log('in here')
    // window.location = document.location.hash
    // const hash = window.location.hash
    const accordionItem = document.querySelector('#' + paths[4])

    // if this hash is an accordion item
    if (accordionItem) {
      const parent = accordionItem.parentElement
      console.log('parent', parent)
      if (parent.classList.contains('not-active')) {
        const btn = document.querySelector('[data-tab-name=' + parent.dataset.tab + ']')
        toggleTab(btn)
        setTimeout( () => {
          openAccordion(accordionItem)
        }, 350)
      } else {
        openAccordion(accordionItem)
        setTimeout( () => {
          openAccordion(accordionItem)
        }, 350)
      }
    }
  }
})

accordionItems.forEach( accordion => {
  const btn = accordion.querySelector('[data-accordion-toggle]')
  btn.addEventListener('click', () => {
    toggleAccordion(accordion)
  })
})

tabBtns.forEach( btn => {
  btn.addEventListener('click', () => {
    toggleTab(btn)
  })
})

window.addEventListener('resize', () => {
  accordionItems.forEach( accordion => {
    setTop(accordion)
  })
})

/**
 * Toggle Tab
 * @param {obj} btn the trigger button 
 */
function toggleTab(btn) {
  // close existing accordion item
  if (currentAccordion) closeAccordion(currentAccordion)

  // toggle tab
  if (!btn.classList.contains('is-active')) {
    const activeTabName = btn.dataset.tabName

    // update classes
    btn.classList.add('is-active')
    btn.setAttribute('aria-selected', true)
    tabBtns.forEach( tabBtn => {
      if (tabBtn !== btn) {
        if (tabBtn.classList.contains('is-active')) {
          tabBtn.classList.remove('is-active')
          tabBtn.setAttribute('aria-selected', false)
        } 
      }
    })

    // toggle tabs
    tabs.forEach( tab => {
      if (tab.dataset.tab === activeTabName) {
        tab.classList.add('is-active')
        if (tab.classList.contains('not-active')) tab.classList.remove('not-active')
      } else {
        if (tab.classList.contains('is-active')) tab.classList.remove('is-active')
        tab.classList.add('not-active')
      }
    })
  } 
}

/**
 * Toggle accordion
 * @param {obj} accordion 
 */
function toggleAccordion(accordion) {
  if (accordion.classList.contains('is-open')) {
    closeAccordion(accordion)
    currentAccordion = false
  } else {
    if (currentAccordion) closeAccordion(currentAccordion)
    openAccordion(accordion)
  }
}

function closeAccordion(accordion) {
  const content = accordion.querySelector('[data-accordion-content]')
  accordion.classList.remove('is-open')
  content.style.height = 0

  // btn / aria stuff
  const btn = accordion.querySelector('[data-accordion-toggle]')
  const btnInner = btn.querySelector('span')
  btn.setAttribute('aria-expanded', false)
  btnInner.innerHTML = 'Open'
}

function openAccordion(accordion) {
  const content = accordion.querySelector('[data-accordion-content]')
  const innerContent = content.querySelector('.accordion__inner')
  const height = innerContent.offsetHeight
  accordion.classList.add('is-open')
  content.style.height = height + 'px'

  // btn / aria stuff
  const btn = accordion.querySelector('[data-accordion-toggle]')
  const btnInner = btn.querySelector('span')
  btn.setAttribute('aria-expanded', true)
  btnInner.innerHTML = 'Close'

  // scrollToTop
  setTimeout( () => {
    window.scrollTo({
      top: accordion.dataset.top,
      left: 0,
      behavior: 'smooth'
    })
  }, 100)

  // set current accordion
  currentAccordion = accordion

  // // update meta
  // accordionShare()

  // update measurements
  setTop(accordion)
}

function setTop(accordion) {
  accordion.dataset.top = accordion.getBoundingClientRect().top + window.scrollY - 20
}

// function accordionShare() {
//   console.log('not')
//   const cachebust = Math.floor(Date.now() / 1000)
//   const shareLinks = document.querySelectorAll('.accordion__share')

//   console.log(Math.floor(Date.now() / 1000))

//   shareLinks.forEach( link => {
//     link.addEventListener('click', e => {
//       e.preventDefault()
//       console.log(link.dataset.shareimage)
//       const metaTitle = document.querySelector('meta[name="og:title"]')
//       const metaImg= document.querySelector('meta[name="og:image"]')
//       const head = document.querySelector('head')

//       if (metaTitle) {
//         metaTitle.setAttribute('content', 'test 1')
//       } else {
//         const addMetaTitle = document.createElement('meta')
//         addMetaTitle.setAttribute('property', 'og:title')
//         addMetaTitle.setAttribute('content', 'test 2')
//         head.append(addMetaTitle)
//       }
//       if (metaImg) {
//         metaImg.setAttribute('content', 'test 1')
//       } else {
//         const addMetaImg = document.createElement('meta')
//         addMetaImg.setAttribute('property', 'og:image')
//         addMetaImg.setAttribute('content', encodeURI(link.dataset.shareimage + '?' + cachebust))
//         head.append(addMetaImg)
//       }

//       window.open(link.href, '', 'target="_blank"')
//     })
//   })
// }

// function test() {
//   const metaTitle = document.querySelector('meta[name="og:title"]')
//   const metaImg= document.querySelector('meta[name="og:image"]')
//   const head = document.querySelector('head')
//   const cachebust = Math.floor(Date.now() / 1000)

//   const shareLink = document.querySelectorAll('.accordion__share')
//   console.log(shareLink[1].dataset.shareimage)

//   if (metaTitle) {
//     metaTitle.setAttribute('content', 'test 1')
//   } else {
//     const addMetaTitle = document.createElement('meta')
//     addMetaTitle.setAttribute('property', 'og:title')
//     addMetaTitle.setAttribute('content', 'test 2')
//     head.append(addMetaTitle)
//   }
//   if (metaImg) {
//     metaImg.setAttribute('content', 'test 1')
//   } else {
//     const addMetaImg = document.createElement('meta')
//     addMetaImg.setAttribute('property', 'og:image')
//     addMetaImg.setAttribute('content', encodeURI(shareLink[1].dataset.shareimage + '?' + cachebust))
//     head.append(addMetaImg)
//   }
// }

// test()